export default __webpack_public_path__ + "1a64b9a9a172d067c8203f2b03ab7e61.woff2";